import { apiClient } from './apiService';
import { TABLE_REPORTS } from './endpoints';
import {
  EmployeePerformanceRow,
  TableOccupancyDuration,
  TablePeakHours,
  TablePerformanceRow,
  TableReportBundle,
  TableReportOverview,
  TableReportQuery,
  TableWaitlistStats
} from '@/types/TableReport.interface';

const params = (query: TableReportQuery) => ({
  branchId: String(query.branchId),
  startDate: query.startDate,
  endDate: query.endDate,
  timezone: query.timezone
});

const get = async <T>(path: string, query: TableReportQuery): Promise<T> => {
  const response = await apiClient.get<T>(
    `${TABLE_REPORTS}/${path}`,
    params(query)
  );
  return response.data;
};

/** Restaurant reports of one branch (tables, waiters, hours, waitlist). */
export const tableReportService = {
  getOverview: (query: TableReportQuery) =>
    get<TableReportOverview>('overview', query),
  getTablePerformance: (query: TableReportQuery) =>
    get<TablePerformanceRow[]>('table-performance', query),
  getEmployeePerformance: (query: TableReportQuery) =>
    get<EmployeePerformanceRow[]>('employee-performance', query),
  getPeakHours: (query: TableReportQuery) =>
    get<TablePeakHours>('peak-hours', query),
  getOccupancyDuration: (query: TableReportQuery) =>
    get<TableOccupancyDuration>('occupancy-duration', query),
  getWaitlistStats: (query: TableReportQuery) =>
    get<TableWaitlistStats>('waitlist-stats', query),

  /** All six at once; one failure fails the whole report. */
  async getAll(query: TableReportQuery): Promise<TableReportBundle> {
    const [overview, tables, employees, peakHours, occupancy, waitlist] =
      await Promise.all([
        this.getOverview(query),
        this.getTablePerformance(query),
        this.getEmployeePerformance(query),
        this.getPeakHours(query),
        this.getOccupancyDuration(query),
        this.getWaitlistStats(query)
      ]);
    return { overview, tables, employees, peakHours, occupancy, waitlist };
  }
};
